import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { onEnterKeyPress } from 'helpers/Account';
import OverlayFooter from 'components/OverlayFooter';
import { noop } from 'helpers/GlobalHelper';
import Header from '../Header';
import ForgotPasswordCTA from '../ForgotPasswordCTA';

import Style from './FacebookLinking.module.scss';

const FacebookLinking = ({
  facebookLinkingEmail,
  facebookLinkingEmailError,
  facebookLinkingGenericError,
  facebookLinkingPassword,
  facebookLinkingPasswordError,
  facebookLinkingShowPassword,
  forgotPasswordCTAProps,
  headerProps,
  language,
  onFieldChange,
  onLinkFacebook,
}) => {
  const {
    profile_emailInputPlaceholder: emailPlaceholder,
    profile_passwordInputPlaceholder: passwordPlaceholder,
    profile_genericErrorSignInMessage: signinErrorMessage,
    profile_facebookExistingLinkHeader: linkHeader,
    profile_facebookExistingLinkMessage: linkMessage,
    profile_facebookExistingLinkButton: linkButtonText,
    profile_passwordInvalidError: invalidPasswordError,
    profile_emailInvalidError: emailInvalidError,
  } = language || {};
  let fbLinkPasswordInput = React.createRef();
  let passwordErrorText;
  let emailErrorText;
  let passwordErrorClass;
  let emailErrorClass;
  const passwordType = facebookLinkingShowPassword ? 'text' : 'password';
  let errorText = facebookLinkingGenericError ? signinErrorMessage : null;
  if (facebookLinkingGenericError === 'Invalid LoginID') {
    errorText = invalidPasswordError;
  }

  if (facebookLinkingPasswordError) {
    passwordErrorText = facebookLinkingPasswordError;
    passwordErrorClass = Style.error;
  }

  if (facebookLinkingEmailError) {
    emailErrorText = emailInvalidError;
    emailErrorClass = Style.error;
  }
  return (
    <main className={Style.facebookLinking}>
      <Header {...headerProps} />
      <div className={Style.facebookLinkingWrap}>
        <div className={Style.headerTextDesktop}>{linkHeader}</div>
        <div className={Style.facebookLinkingDescriptionText}>{linkMessage}</div>
        <div className={Style.signupFormContainer}>
          <div className={Style.error}>{errorText}</div>
          <input
            className={classNames(
              Style.signupField,
              Style.facebookLinkingField,
              Style.facebookLinkingEmailField,
              emailErrorClass,
            )}
            type="email"
            name="facebookLinkingEmail"
            placeholder={emailPlaceholder}
            value={facebookLinkingEmail}
            onChange={onFieldChange}
            autoCapitalize="none"
            disabled
          />
          <div className={Style.error}>{emailErrorText}</div>
          <div className={Style.signupPasswordContainer}>
            <input
              autoFocus
              className={classNames(
                Style.signupField,
                Style.facebookLinkingField,
                passwordErrorClass,
              )}
              type={passwordType}
              name="facebookLinkingPassword"
              placeholder={passwordPlaceholder}
              value={facebookLinkingPassword}
              onChange={onFieldChange}
              ref={input => {
                fbLinkPasswordInput = input;
              }}
              autoCapitalize="none"
              autoComplete="off"
              autoCorrect="off"
              spellCheck={false}
              onKeyPress={e => onEnterKeyPress(e, onLinkFacebook)}
            />
            <label className={classNames(Style.signinShowPasswordLabel, passwordErrorClass)}>
              <input
                name="facebookLinkingShowPassword"
                type="checkbox"
                value={facebookLinkingShowPassword}
                onChange={e => {
                  onFieldChange(e);
                  fbLinkPasswordInput.focus();
                }}
              />
              <span />
            </label>
          </div>
          <div className={Style.error}>{passwordErrorText}</div>
          <div className={Style.signinButtonDesktop}>
            <button onClick={onLinkFacebook} className={Style.desktopButton}>
              {linkButtonText}
            </button>
          </div>
          <div className={classNames(Style.signupButton, Style.facebookLinkingLinkButton)}>
            <button onClick={onLinkFacebook} className={Style.btnPrimary}>
              {linkButtonText}
            </button>
          </div>
          <ForgotPasswordCTA {...forgotPasswordCTAProps} />
        </div>
      </div>
      <OverlayFooter language={language} />
    </main>
  );
};

FacebookLinking.defaultProps = {
  facebookLinkingEmail: null,
  facebookLinkingEmailError: null,
  facebookLinkingGenericError: null,
  facebookLinkingPassword: null,
  facebookLinkingPasswordError: null,
  facebookLinkingShowPassword: null,
  language: {},
  onFieldChange: noop,
  onLinkFacebook: noop,
};

FacebookLinking.propTypes = {
  facebookLinkingEmail: PropTypes.string,
  facebookLinkingEmailError: PropTypes.bool,
  facebookLinkingGenericError: PropTypes.string,
  facebookLinkingPassword: PropTypes.string,
  facebookLinkingPasswordError: PropTypes.string,
  facebookLinkingShowPassword: PropTypes.bool,
  forgotPasswordCTAProps: PropTypes.shape({}).isRequired,
  headerProps: PropTypes.shape({}).isRequired,
  language: PropTypes.shape({}),
  onFieldChange: PropTypes.func,
  onLinkFacebook: PropTypes.func,
};

export default FacebookLinking;
